import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const KilometersMissionService = {
     async findMissionsKilometer(state = "", reference = "", destination = "", debut = "", fin = "", title = "") {
        const queryParams = new URLSearchParams({
            state,
            reference,
            destination,
            debut,
            fin,
            title
          });
          
        try {
    
            const url = state || reference || destination || debut || fin || title
                ? `${apiUrl}/KilometersMission?${queryParams.toString()}`
                : `${apiUrl}/KilometersMission/`;
    
            const result = await axios.get(url);
            return result?.data || null;
        } catch (err) {
            return err.response ? err.response.data : { error: "Erreur réseau" };
        }
    },  
    
     async updateStateKilometerMission(missionId, state){
        try{
            const result = await axios.post(`${apiUrl}/KilometersMission/updateState` , {
                mission_timesheet_id: missionId,
                state: state
            });
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async refusKilometerMission(timesheetId, observation){
        try{
            const result = await axios.post(`${apiUrl}/KilometersMission/refusKilometerMission` , {
                mission_timesheet_id: timesheetId,
                observation: observation
            });
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },

     async saveKilometerMission(kilometersMission){
        try{
            const result = await axios.post(`${apiUrl}/KilometersMission/`,kilometersMission);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },

     async generateKilometragesFile(missionId, agendaId = 0){
            try{
                const result = await axios.get(`${apiUrl}/KilometersMission/generateAndSendKilometers/` + missionId + "/" + agendaId, 
                   );
                if (result) {
                    return result.data;
                }
            } catch (err){
                if (err.response) {
                    return err.response.data;
                }
            }
        },
     async downloadKilometrages(missionId, timesheetId = 0, agendaId = 0){ 
        try {
            const response = await axios.get(`${apiUrl}/KilometersMission/downloadKilometrages?mission_planning_id=` + missionId + '&mission_timesheet_id=' + timesheetId + '&mission_planning_agenda_id=' + agendaId, {
                responseType: 'blob',
            });
            return response;
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },

     async getKilometersHistory(timesheetId){
        try{
            const result = await axios.get(`${apiUrl}/KilometersMission/history/` + timesheetId);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async addDestinationKilometerMission(dataTosend){
        try{
            const result = await axios.post(`${apiUrl}/KilometersMission/addDestination` , dataTosend);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async removeDestinationKilometerMission(destinationId){
        try{
            const result = await axios.delete(`${apiUrl}/KilometersMission/removeDestinationKilometer/` + destinationId);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async sendRequestKilometerMission (missionId, destinationId = 0, agendaId = 0, observation = ""){
        try{
            const result = await axios.post(`${apiUrl}/KilometersMission/sendRequestKilometer/` , {
                mission_planning_id: missionId,
                mission_planning_destination_id: destinationId,
                observation: observation,
                mission_planning_agenda_id: agendaId
            });
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },

}

export default KilometersMissionService;